<template>
  <div class="ticket-step">
      <Steps :current="current" style="width:75%">
        <Step title="选择门票"></Step>
        <Step title="填写信息"></Step>
        <Step title="预约完成"></Step>
      </Steps>
  </div>
</template>

<script>
export default {
  props: ['current']
}
</script>

<style scoped>
.ticket-step{
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>

<style lang="less">
  .ticket-step{
    .ivu-steps-head-inner{
      width: 56px;
      height: 56px;
      line-height: 56px;
      font-size: 26px;
    }
    .ivu-steps-tail{
      top: 28px;
    }
    .ivu-steps-main{
      display: block;
      margin-top: 10px;
      width: 68px;
      text-align: center;
    }

  }
</style>
